function createSummary() {

	let h2,
		h2_nb,
		txt_title,
		sommaire_data_offset;

	if ($('.tx_cimcomarquage_content #situation-tabs a').length > 0 ) {
		h2 = $('.tx_cimcomarquage_content .tabs-panel h2:visible');
	} else {
		// h2 = $('.col_left_inner > div:not(.bloc_carrefour) h2:visible, .col_left_inner > header > h2:visible, .col_left_inner > h2:visible, .col_left_inner > div:not(.bloc_carrefour) .titre_bloc .titre:visible:not(h3)');
		h2 = $('.col_left h2:visible:not(.titre)');
	}
	h2_nb = h2.length;
	txt_title = $(".sommaire").attr("data-txt-title");

	// Creation du sommaire et des ancres si presence de h2
	if (h2_nb) {
		// Ajout d'une classe sur content_page si presence du sommaire
		// $('.content_page').addClass("hasSommaire");
		let url = window.location.href;
		let array = [];
		h2.each(function(index){

			// Ajout d'ancres dans le contenu avant les h2
			$(this).before( '<div id="ligne_' + index + '" class="magellan_anchor" data-magellan-target="ligne_' + index + '" tabindex="0"></div>' );

			// On stocke les titres dans un tableau
			let h2_title = $(this).text();
			let link = '<li><a href="#ligne_' + index + '">' + h2_title + '</a></li>';
			array.push(link);
		});

		// Creation du sommaire
		$('.sommaire').append('<div class="titre_bloc show-for-large"><h2 class="titre">' + txt_title +'</h2></div><div id="menu_sommaire" class="content_bloc" data-magellan data-offset="116" data-threshold="0" ><nav><ul>' + array.join("") + '</ul></nav></div>');

		// Init composant magellan car manip du dom
		$('.sommaire').foundation();

	} else {
		$('.col_right').remove();
		$('.col_left').removeClass('xlarge-offset-1');
	}
}

$("#situation-tabs").on('change.zf.tabs',function(){
	$("#sommaire").empty();
	$(".tabs-panel[aria-hidden='true'] .magellan_anchor").remove();
	createSummary();
});

$(document).bind('_js_ready list.popin.open', function() {

	if (!$('#page').hasClass('list') && ($('#menu_sommaire').length == 0)) {
		createSummary();
	}

	// Apparition des element au scroll dans la colonne de droite
		// $(".col_right_inner").scroll(function() { animate(); });

	$("#sommaire nav a").on('click',function(){

		let e = $(this).attr("href");
		$("#menu_sommaire").one('update.zf.magellan',function(){
			$(this).foundation("calcPoints");
			$(this).foundation("reflow"),
			$(this).foundation("scrollToLoc", e);
			let t = $("#menu_sommaire a.is-active").attr("href");
			$(t).focus();
		});

	});

});